import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

export interface CheckEmailData {
	email: string;
}

export type CheckEmailResponse = void;

const checkEmail = configRequest<CheckEmailResponse, CheckEmailData>({
	requestPrefix: 'auth/checkEmail',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.CHECK_EMAIL(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export default checkEmail;
